import { ADD_USER, ADD_USER_SUCCESS, ADD_USER_FAIL,USERS_LOADING } from "./actionType"

const initialState = {
  error: "",
  success: "",
  loading:false
}

const AddUser = (state = initialState, action) => {
  switch (action.type) {
    case ADD_USER:
      state = {
        ...state,
      }
      break
    case ADD_USER_SUCCESS:
      state = { ...state, success: action.payload,loading:false }
      break
    case ADD_USER_FAIL:
      state = { ...state, error: action.payload,loading:false }
      break
      case USERS_LOADING:
        state={
          loading: action.payload,
        }
  }
  return state
}

export default AddUser
